module.exports = __webpack_public_path__ + "img/standardXDCJ.01223f1d.png";